export default {
  data() {
    return {
      measuredHeight: 0,
      resizeObserver: null
    }
  },

  methods: {
    measure() {
      const el = this.$refs.measureTarget
      if (el && el.scrollHeight !== this.measuredHeight) {
        this.measuredHeight = el.scrollHeight
      }
    }
  },

  mounted() {
    this.$nextTick(() => {
      requestAnimationFrame(this.measure)
      const el = this.$refs.measureTarget
      if (el && typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(this.measure)
        this.resizeObserver.observe(el)
      }
    })
  },

  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
  }
}
